export default {
  // Commenting out for now.
  // read account data
  // getUser(userID) {
  //   const obj = {
  //     actionType: appConstants.ActionTypes.GET_USER,
  //     postData: {},
  //   };
  //   obj.postData[Utils.getEndpointParam('USER_ID')] = userID;
  //   MakeShiftEmployeeDispatcher.dispatch(obj);
  // },

  getLocationInfo(locationID) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_LOCATION,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')] = locationID;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  updateEmail(account_id, new_email) {
    return new_email;
  },

  getSharedCalendar() {
    const obj = {
      actionType: appConstants.ActionTypes.GET_SHARED_CALENDAR,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EMAIL_PARAM')] = Utils.getCoreUser().email;
    obj.postData[Utils.getEndpointParam('SKIP_DELIVERY')] = true;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  sendSharedCalendar(email, skip) {
    const obj = {
      actionType: appConstants.ActionTypes.SEND_SHARED_CALENDAR,
      postData: {},
    };
    const skipDelivery = !_.isUndefined(skip) ? skip : false;
    obj.postData[Utils.getEndpointParam('EMAIL_PARAM')] = email;
    obj.postData[Utils.getEndpointParam('SKIP_DELIVERY')] = skipDelivery;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  resetPassword(email) {
    const obj = {
      actionType: appConstants.ActionTypes.REQUEST_PASSWORD,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EMAIL_PARAM')] = email;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
  removeSharedCalendar(schedule_share_id) {
    const obj = {
      actionType: appConstants.ActionTypes.REMOVE_SHARED_CALENDAR,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('SCHEDULE_SHARE_ID_PARAM')] = schedule_share_id;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
